import { MultiplierDisplay } from '@components/game/MultiplierDisplay';
import { BettingPanel } from '@components/game/BettingPanel';
import { CashOutButton } from '@components/game/CashOutButton';
import { CrashHistory } from './CrashHistory';

/**
 * Main game UI overlay
 * Contains betting panel, multiplier display, cash out button
 */
export function GameUI(): React.JSX.Element {
  return (
    <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-between p-4">
      {/* Top: Crash History and Multiplier Display */}
      <div className="flex w-full flex-col items-center gap-4 pt-4">
        <CrashHistory />
        <MultiplierDisplay />
      </div>

      {/* Center: Cash Out Button (appears during playing phase) */}
      <div className="pointer-events-auto">
        <CashOutButton />
      </div>

      {/* Bottom: Betting Panel */}
      <div className="pointer-events-auto w-full max-w-md pb-4">
        <BettingPanel />
      </div>
    </div>
  );
}
